
























import { Notification } from '@/models';
import { getNotificationsAudioMixin } from '@/shared';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import NotificationModal from './NotificationModal.vue';
import NotificationItem from './NotificationItem.vue';

export default mixins(getNotificationsAudioMixin('fanfare-level')).extend({
  name: 'AchievementNotifications',
  components: {
    NotificationModal,
    NotificationItem,
  },
  props: {
    notifications: Array as () => Notification[],
  },
  data() {
    return {
      visibleNotificationIndex: -1,
    };
  },
  mounted() {
    if (this.achievementNotifications.length === 0) {
      this.$emit('complete');
    } else {
      this.playAudio();
    }
    this.visibleNotificationIndex = 0;
  },
  computed: {
    achievementNotifications(): Notification[] {
      return this.notifications.filter(n => n.type === 'AchievementNotification');
    },
  },
  methods: {
    dismiss() {
      const notification = this.achievementNotifications[this.visibleNotificationIndex];
      this.$emit('dismiss', [notification]);
      this.visibleNotificationIndex++;
      this.stopAudio();

      if (this.visibleNotificationIndex >= this.achievementNotifications.length) {
        this.$emit('complete');
      }
    },
  },
});
